module.exports = __webpack_public_path__ + "img/Order-step.f14f35d4.png";